import axiosInstance from '../utils/axiosConfig';

export interface Category {
    id: number;
    name: string;
    slug: string;
    description: string;
    difficulty_level: number;
    order_index: number;
    games_count: number;
    valid_until: string | null;
    is_valid: boolean;
}

interface UserState {
    completed_variations: number;
    total_variations: number;
    accuracy: number;
    correct_moves: number;
    wrong_moves: number;
    total_moves: number;
    completion_rate: number;
    last_played_at: string | null;
}

interface GameWithState {
    id: number;
    title: string;
    description: string;
    difficulty: number;
    category_id: number;
    piece_color: string;
    user_state: UserState | null;
}

export interface CategoryGamesResponse {
    total: number;
    pages: number;
    current_page: number;
    per_page: number;
    category: Category;
    games: GameWithState[];
}

export const categoryService = {
    getCategories: async (): Promise<Category[]> => {
        const response = await axiosInstance.get('/category/categories');
        return response.data;
    },

    getCategoryGames: async (categoryId: number, page: number = 1, pageSize: number = 12): Promise<CategoryGamesResponse> => {
        const response = await axiosInstance.get(`/category/${categoryId}/games`, {
            params: {
                page,
                per_page: pageSize
            }
        });
        return response.data;
    }
}; 